<template>
  <div>
    <el-skeleton animated>
      <template slot="template">
        <div class='item item1'>
          <el-skeleton-item class="circle" variant="circle"/>
          <el-skeleton-item class="h1" variant="h1"/>
        </div>
        <div class='item item2'>
          <el-skeleton-item class="circle" variant="circle"/>
          <el-skeleton-item class="text" variant="h1"/>
        </div>
        <div class='item item3'>
          <el-skeleton-item class="circle" variant="circle"/>
          <el-skeleton-item class="h1" variant="h1"/>
        </div>
        <div class='item item4'>
          <el-skeleton-item class="circle" variant="circle"/>
          <el-skeleton-item class="text" variant="h1"/>
        </div>
      </template>
    </el-skeleton>
  </div>
</template>

<script>
export default {
  data() {
      return {

      };
  },
  methods: {

  },
};
</script>

<style scoped lang="scss">
  /deep/ .el-skeleton{
    .item {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      padding-bottom: 25px;
      .circle {
        width: 26px;
        height: 26px;
      }
      .h1 {
        width: 50%;
        height: 40px;
        margin-left: 18px;
      }
      .text {
        width: 70%;
        height: 100px;
        margin-left: 18px;
      }
    }
    .item3 {
      .h1 {
        width: 60%;
      }
    }
    .item2 {
      align-items: flex-start;
      padding-bottom: 40px;
      .text {
        height: 70px;
        width: 70%;
      }
    }
    .item4 {
      align-items: flex-start;
      .text {
        width: 85%;
      }
    }
  }

</style>
